import type { Player } from '@infiltre/shared';
import { useT } from '@/shared/lib/i18n';
import { PhaseHeader } from '@/shared/ui';
import { VoteCandidateGrid } from './vote/VoteCandidateGrid';

export type VoteBoardProps = {
  voter: Player;
  candidates: readonly Player[];
  onVote: (targetId: string) => void;
};

/**
 * Online vote target picker. Tapping a polaroid card casts the vote
 * immediately. The phase header up top + polaroid grid below mirror
 * the standalone `EliminatePicker` so both modes feel like the same
 * surface.
 */
export const VoteBoard = ({ voter, candidates, onVote }: VoteBoardProps) => {
  const t = useT();
  return (
    <main className="mx-auto flex h-full w-full max-w-3xl flex-col">
      <PhaseHeader
        eyebrow={t('round.vote.phase_eyebrow')}
        title={t('round.vote.title')}
        descriptor={t('round.vote.descriptor')}
      />
      <div className="flex flex-1 flex-col items-center px-5 pt-5 pb-6">
        <div className="mb-4 type text-[10px] text-ink/55 uppercase tracking-[0.22em]">
          {t('round.vote.eyebrow', { name: voter.name })}
        </div>
        <VoteCandidateGrid candidates={candidates} onPick={onVote} />
      </div>
    </main>
  );
};
